(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-countdown-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.matsuCampaignCountdownStickyLoaded) return;
    window.matsuCampaignCountdownStickyLoaded = true;

    const selector = '[data-campaign-countdown-bar]';

    const updateCampaignBarHeight = () => {
      const bar = Array.from(document.querySelectorAll(selector)).find((element) => {
        return element.isConnected && element.offsetParent !== null;
      });
      const height = bar ? Math.ceil(bar.getBoundingClientRect().height) : 0;

      document.documentElement.style.setProperty('--campaign-countdown-bar-height', `${height}px`);
    };

    const scheduleUpdate = () => requestAnimationFrame(updateCampaignBarHeight);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleUpdate);
    } else {
      scheduleUpdate();
    }

    window.addEventListener('resize', scheduleUpdate);
    document.addEventListener('theme:resize', scheduleUpdate);
    document.addEventListener('theme:resize:width', scheduleUpdate);
    document.addEventListener('shopify:section:load', scheduleUpdate);
    document.addEventListener('shopify:section:unload', scheduleUpdate);

    if (document.body) {
      new MutationObserver(scheduleUpdate).observe(document.body, {childList: true, subtree: true});
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-ugc-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ugc-carousel')) {
    customElements.define('ugc-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-ugc-track]');
        this.slides = Array.from(this.querySelectorAll('[data-ugc-slide]'));
        this.copies = Array.from(this.querySelectorAll('[data-ugc-copy]'));
        this.dots = Array.from(this.querySelectorAll('[data-ugc-dot]'));
        this.activeIndex = 0;

        if (!this.track || !this.slides.length) return;

        this.querySelector('[data-ugc-prev]')?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
        this.querySelector('[data-ugc-next]')?.addEventListener('click', () => this.goTo(this.activeIndex + 1));
        this.dots.forEach((dot) => dot.addEventListener('click', () => this.goTo(Number(dot.dataset.ugcDot))));

        this.handleScroll = () => {
          window.clearTimeout(this.scrollTimer);
          this.scrollTimer = window.setTimeout(() => this.updateActiveFromScroll(), 100);
        };
        this.track.addEventListener('scroll', this.handleScroll, { passive: true });
        this.setActive(0);

        this.addEventListener('shopify:block:select', (event) => {
          const index = this.slides.findIndex((slide) => slide.contains(event.target) || slide.dataset.ugcSlide === event.target.dataset.ugcSlide);
          const copyIndex = this.copies.findIndex((copy) => copy === event.target || copy.contains(event.target));
          this.goTo(index > -1 ? index : copyIndex);
        });
      }

      disconnectedCallback() {
        this.track?.removeEventListener('scroll', this.handleScroll);
        window.clearTimeout(this.scrollTimer);
      }

      updateActiveFromScroll() {
        const trackLeft = this.track.getBoundingClientRect().left;
        let closestIndex = 0;
        let closestDistance = Infinity;

        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        this.setActive(closestIndex);
      }

      goTo(index) {
        if (index < 0) index = this.slides.length - 1;
        if (index >= this.slides.length) index = 0;
        const slide = this.slides[index];
        const targetLeft = slide.offsetLeft - this.track.offsetLeft;
        this.track.scrollTo({ left: targetLeft, behavior: 'smooth' });
        this.setActive(index);
      }

      setActive(index) {
        if (Number.isNaN(index) || !this.slides[index]) return;
        this.activeIndex = index;

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          const video = slide.querySelector('video');
          if (!video) return;
          if (active && this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
        });

        this.copies.forEach((copy, copyIndex) => copy.classList.toggle('is-hidden', copyIndex !== index));
        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
